<template>
    <v-dialog :value="value" persistent @input="$emit('input', $event)" max-width="900" class="invitation__detail">
        <section class="invitation__detail__content">
            <header v-if="selectedInvitation.inviter" class="invitation__detail__content__header">
                <article>
                    <p class="invitation__detail__content__header--title">Invitador: {{
                        selectedInvitation.inviter.name }}</p>
                    <p class="invitation__detail__content__header--subtitle">
                        Invitado: {{ selectedInvitation.invited.name }}
                    </p>
                    <p class="invitation__detail__content__header--subtitle"
                        v-if="selectedInvitation && selectedInvitation.month">
                        Mes: {{ selectedInvitation.month }}
                    </p>
                    <p v-else class="invitation__detail__content__header--subtitle">General</p>
                </article>
            </header>

            <section class="invitation__detail__content__body">
                <InvitationDetailModalSkeleton v-if="isLoading" />

                <v-alert v-else-if="isError" :value="isError" color="error" icon="warning" outline>
                    {{ error }}
                </v-alert>

                <v-alert class="empty" type="info" v-else-if="isEmpty" :value="isEmpty">
                    {{ emptyMessage }}
                </v-alert>

                <div class="invitation__detail__content__invitations" v-else>
                    <v-expansion-panel class="invitation__detail__content__invitations__body" expand>
                        <v-expansion-panel-content v-for="invitation in invitationList" :key="invitation.id">
                            <template v-slot:header>
                                <div class="invitation__detail__content__invitations__body--header">Fecha de
                                    invitación: <b>{{ formatToColombiaDate(invitation.created_at) }}</b>
                                </div>
                            </template>
                            <div class="invitation__detail__content__invitations__body--content">

                                <div class="invitation__detail__content__invitations__body--content__item--photo">
                                    <img :src="invitation.invitation_photo || 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png'"
                                        class="invitation__detail__content__invitations__body--content__item--photo--detail" />
                                </div>

                                <div class="invitation__detail__content__invitations__body--content__item">
                                    <h4>Invitado</h4>
                                    <p>{{ invitation.invited_person.name }}</p>
                                </div>

                                <div class="invitation__detail__content__invitations__body--content__item">
                                    <h4>Lugar</h4>
                                    <p>{{ invitation.location.name }}</p>
                                </div>

                                <div class="invitation__detail__content__invitations__body--content__item">
                                    <h4>Teléfono</h4>
                                    <p>{{ invitation.invited_person.mobile }}</p>
                                </div>

                                <div class="invitation__detail__content__invitations__body--content__item">
                                    <h4>Tipo</h4>
                                    <p>{{ invitation.visit_reason.name }}</p>
                                </div>

                                <div class="invitation__detail__content__invitations__body--content__item">
                                    <h4>Válida desde</h4>
                                    <p>{{ formatToColombiaDate(invitation.valid_from) }}</p>
                                </div>

                                <div class=" invitation__detail__content__invitations__body--content__item">
                                    <h4>Válida hasta</h4>
                                    <p>{{ formatToColombiaDate(invitation.valid_until) }}</p>
                                </div>

                                <div class="invitation__detail__content__invitations__body--content__item">
                                    <h4>Estado</h4>
                                    <div class="invitation__detail__content__invitations__body--content__item--status__badge"
                                        :class="`invitation__detail__content__invitations__body--content__item--status__badge--${invitation.invitation_category}`">
                                        {{ getStatusText(invitation.invitation_category) }}
                                    </div>
                                </div>

                            </div>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </div>
            </section>

            <footer class="invitation__detail__content__footer">
                <div class="invitation__detail__content__footer__close">
                    <button class="invitation__detail__content__footer__close--button" @click="closeDialog">
                        Cerrar
                    </button>
                </div>
                <div class="invitation__detail__content__footer__pagination">
                    <button class="invitation__detail__content__footer__pagination--prev"
                        :disabled="pagination.currentPage === 1 || isLoading" @click="handlePrev">
                        Anterior
                    </button>

                    <button class="invitation__detail__content__footer__pagination--next"
                        :disabled="!hasNextPage || isLoading" @click="handleNext">
                        Siguiente
                    </button>

                </div>
            </footer>

        </section>
    </v-dialog>
</template>

<script>
import DashboardService from '../../services/DashboardService';
import InvitationDetailModalSkeleton from './InvitationDetailModalSkeleton.vue';
import { formatToColombiaDate } from '../../lib/helpers';

const STATUS_MAP = {
    approved: "Aprobada",
    cancelled: "Cancelada",
    expired: "Vencida",
    pending: "Pendiente",
    created: "Creada",
    denied: "Denegada"
}

export default {
    components: {
        InvitationDetailModalSkeleton
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        selectedInvitation: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            pagination: {
                currentPage: 1,
                perPage: 6,
            },
            data: null,
            loading: false,
            error: null,

        }
    },
    methods: {
        getStatusText(status) {
            return STATUS_MAP[status]
        },
        handleNext() {
            if (this.isLoading) return;
            this.pagination.currentPage++
            this.getInvitationDetail(this.pagination.currentPage)
        },
        handlePrev() {
            if (this.isLoading) return;
            this.pagination.currentPage--
            this.getInvitationDetail(this.pagination.currentPage)
        },
        reset() {
            this.pagination.currentPage = 1;
            this.error = null;
            this.data = null
        },
        closeDialog() {
            this.$emit("input", false);
        },
        formatToColombiaDate,
        async getInvitationDetail(page) {

            // Check if there is a invitation selected
            if (!this.selectedInvitation || !this.selectedInvitation.inviter) return;

            this.loading = true;

            try {

                const params = {
                    user_id: this.selectedInvitation.inviter.id,
                    mobile: this.selectedInvitation.mobile,
                    month: this.selectedInvitation.month,
                    page: page || 1,
                    per_page: this.pagination.perPage
                };

                const data = await DashboardService.getTopInvitationDetail(params);
                this.data = data
                this.error = null;

            } catch (error) {

                this.error = error.message || "Algo salió mal"
                this.data = null

            } finally {
                this.loading = false;
            }
        }
    },
    computed: {
        invitationList() {
            return (this.data && this.data.invitations) ? this.data.invitations : [];
        },
        hasNextPage() {
            const totalCount = this.data?.total_count || 0
            if (totalCount === 0) return false;
            return this.pagination.currentPage < Math.ceil(totalCount / this.pagination.perPage);
        },
        isLoading() {
            return this.loading
        },
        isError() {
            return !!this.error;
        },
        isEmpty() {
            return (
                !this.isLoading &&
                !this.isError &&
                this.invitationList.length === 0
            )
        },
        emptyMessage() {
            if (this.isLoading) return null;

            const invitedName = this.selectedInvitation?.invited?.name || '';

            if (!invitedName) return null;

            if (this.selectedInvitation?.month) {
                return `No hay invitaciones para ${invitedName} en el mes ${this.selectedInvitation.month}`;
            }

            return `No hay invitaciones para ${invitedName}`;
        }
    },
    emits: ["input"],
    watch: {
        value(open) {
            // reset the data every time the modal is opened so we don't show stale data
            if (open && this.selectedInvitation.inviter) {
                this.reset();
                this.getInvitationDetail();
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import "../../assets/stylesheets/themes/_dashboard.scss";
@import "../../assets/stylesheets/utilities/_mixins.scss";

.empty {
    @include empty-alert()
}

.invitation__detail {
    &__content {
        background: #ffffff;
        border-radius: 20px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        max-height: 80vh;
        height: 70vh;

        &__header {
            flex-shrink: 0;
            display: flex;
            gap: 1rem;
            padding: 1.5rem;
            border-bottom: 1px solid rgba(0, 0, 0, 0.08);
            background: #f8f9fa;

            &--title {
                font-weight: 700;
                font-size: 1.1rem;
                color: #111;
                margin: 0;
            }

            &--subtitle {
                font-size: 0.9rem;
                color: #666;
                margin: 0;
            }
        }

        &__body {
            flex-grow: 1;
            overflow-y: auto;
            overflow-x: hidden;
            padding: 0;
            min-height: 0;


        }

        &__invitations {
            padding: 1rem;

            &__body {
                &--content {
                    display: grid;
                    grid-template-columns: auto repeat(7, 1fr);
                    gap: 1rem;
                    padding: 1.5rem;
                    align-items: start;


                    &__item {
                        h4 {
                            font-size: 0.75rem;
                            text-transform: capitalize;
                            margin-bottom: 0.25rem;
                            font-weight: 700;
                        }

                        p {
                            margin: 0;
                            font-size: 0.9rem;
                            color: #333;
                            font-weight: 500;
                        }

                        &--photo {
                            margin-right: 0.5rem;

                            &--detail {
                                width: 60px;
                                height: 60px;
                                border-radius: 12px;
                                object-fit: cover;
                                border: 1px solid #eee;
                            }
                        }

                        &--status__badge {
                            display: inline-block;
                            padding: 4px 12px;
                            border-radius: 50px;
                            font-size: 0.75rem;
                            font-weight: 600;
                            color: white;
                            text-transform: capitalize;

                            &--created {
                                background-color: $created-color;
                            }

                            &--approved {
                                background-color: $green-color;
                            }

                            &--denied {
                                background-color: $red-color;
                            }

                            &--cancelled {
                                background-color: $blue-color;
                            }

                            &--expired {
                                background-color: $warning-color;
                            }

                            &--pending {
                                background-color: #9b59b6;
                            }
                        }
                    }
                }


                @media screen and (max-width: 960px) {
                    &--content {
                        grid-template-columns: repeat(4, 1fr);

                        &__item--photo {
                            grid-column: 1 / -1;
                            display: flex;
                            justify-content: flex-start;
                            margin-bottom: 1rem;
                        }
                    }
                }

                @media screen and (max-width: 600px) {
                    &--content {
                        grid-template-columns: 1fr 1fr;
                        gap: 1.2rem 1rem;
                        padding: 1rem;

                        &__item--photo {
                            grid-column: 1 / -1;
                            justify-content: flex-start;
                            margin-bottom: 0.5rem;

                            img {
                                width: 50px;
                                height: 50px;
                            }
                        }

                        .status-area {
                            grid-column: 1 / -1;
                            margin-top: 0.5rem;
                        }
                    }
                }


            }
        }

        &__footer {
            flex-shrink: 0;
            display: flex;
            justify-content: space-between;
            padding: 1rem 1.5rem;
            border-top: 1px solid rgba(0, 0, 0, 0.08);
            background: #f8f9fa;


            &__close {
                &--button {
                    padding: 0.6rem 1.3rem;
                    border: 1px solid #ddd;
                    border-radius: 8px;
                    background: white;
                    color: #333;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.2s;

                    &:hover {
                        background: #eee;
                    }
                }
            }

            &__pagination {
                display: flex;
                gap: 4px;

                button:disabled {
                    background-color: #ccc;
                    color: #888;
                    cursor: not-allowed;
                    opacity: 0.6;
                }

                &--prev {
                    padding: 0.6rem 1.3rem;
                    border: 1px solid #ddd;
                    border-radius: 8px;
                    color: #333;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.2s;

                    &:hover {
                        background: #eee;
                    }
                }

                &--next {
                    padding: 0.6rem 1.3rem;
                    border: 1px solid #ddd;
                    border-radius: 8px;
                    color: #333;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.2s;

                    &:hover {
                        background: #eee;
                    }
                }
            }
        }

        @media screen and (max-width: 600px) {
            &__footer {
                display: flex;
                gap: 4px;
                flex-direction: column-reverse;

                &__pagination {
                    button {
                        width: 50%;
                    }
                }

                &__close {
                    &--button {
                        width: 100%;
                    }
                }
            }
        }
    }
}
</style>